// eslint-disable-next-line import/no-anonymous-default-export
export default {
  color: {
    backgroundPage: " #1C4166",
    backgroundNavbar: "#2A6199",
    like: "#fff",
    CardColor: "#2A6199",
    CardColorText: "#fff",
    colorNavbar: "#fff",
    textColor: "#fff",
  },

  width: {
    logoWidth: "200px",
  },
  image: {
    logo: "../logo.png",
    logoNav: "../logo_2.png",
  }
};
